import { z } from 'zod';
// Letters + spaces only. Hyphens are transformed away before validation.
// Apostrophes, accents, digits, and all other punctuation are rejected —
// GDS / airlines cannot process them in passenger names.
const PERSON_NAME_REGEX = /^[a-zA-Z ]+$/;
const PERSON_NAME_ERROR = 'Ce champ ne doit contenir que des lettres sans accent ni ponctuation (apostrophes et caractères spéciaux interdits).';
// Le nettoyage vit dans le `preprocess` : la valeur brute n'existe qu'ici, entre
// le corps HTTP et le schéma, et aucune fonction du module ne l'expose.
const personNameBase = z.preprocess((value) => {
    const text = z.string().safeParse(value);
    if (!text.success)
        return value;
    return text.data.replaceAll('-', ' ').replaceAll(/\s+/g, ' ').trim();
}, z.string().min(1).regex(PERSON_NAME_REGEX, PERSON_NAME_ERROR));
const personNameOptional = personNameBase.optional();
export function personName(options = {}) {
    return options.optional ? personNameOptional : personNameBase;
}
